module.exports = __webpack_public_path__ + "static/media/fansfirst-logo-small-fr.992c845b.svg";